var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ResponseErrors } from 'common/enums/common/response-errors.enum';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import * as queryString from 'querystring';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { vkSignIn, yandexSignIn } from 'store/actions/auth';
import history from 'store/history';
import ReturnToLoginButton from './ReturnToLoginButton';
var SocialSignInProcessPage = function (_a) {
    var type = _a.type;
    var dispatch = useDispatch();
    var _b = useLocation(), search = _b.search, hash = _b.hash;
    var queryParams = new URLSearchParams(search);
    var login = useSelector(function (_a) {
        var auth = _a.auth;
        return auth.login;
    });
    useEffect(function () {
        if (['yandex', 'vk'].includes(type)) {
            var code = queryParams.get('code');
            if (code) {
                var handleLogin = function (code) {
                    dispatch(type === 'yandex' ? yandexSignIn(code, 'email') : vkSignIn(code, 'email'));
                };
                handleLogin(code);
            }
        }
        if (type === 'telegram') {
            var queryObj = queryString.parse(hash);
            if (queryObj && queryObj['#tgAuthResult']) {
                var telegramUserData = JSON.parse(atob(queryObj['#tgAuthResult']));
                history.push("/tg?id=".concat(telegramUserData.id, "&first_name=").concat(telegramUserData.first_name, "&username=").concat(telegramUserData.username).concat(telegramUserData.last_name ? "&last_name=".concat(telegramUserData.last_name) : '', "&photo_url=").concat(telegramUserData.photo_url, "&auth_date=").concat(telegramUserData.auth_date, "&hash=").concat(telegramUserData.hash));
            }
        }
    }, []);
    if ((login === null || login === void 0 ? void 0 : login.error) && login.error.errorCode === ResponseErrors.NoDataFromSocial)
        return (_jsx("div", __assign({ className: "w-full h-full flex items-center justify-center" }, { children: _jsx(ReturnToLoginButton, {}, void 0) }), void 0));
    return _jsx(CircularProgressMui, {}, void 0);
};
export default SocialSignInProcessPage;
